import React, { useEffect, useState, useRef } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import ClassNames from 'embla-carousel-class-names';
import { PrevButton, NextButton, usePrevNextButtons } from '../atoms/EmblaCarouselArrowButtons';
const SolidColours = ({ commonColours, currentBundle, selectSolidColor }) => {
    const emblaContainer = useRef(null);
    const classes = {
        hoverLeft: 'embla--hover-left',
        hoverRight: 'embla--hover-right',
    };
    const [solidSelected, setSolidSelected] = useState(null);
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false, align: 'start', skipSnaps: true }, [ClassNames()]);
    const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } = usePrevNextButtons(emblaApi);
    const checkIfAllColourSwatchesAreSame = (variants) => {
        let firstColorSwatch = null;
        let allTheSame = true;
        for (const component in variants) {
            for (const item of variants[component]) {
                if (item.selectedVariant.colour_swatch && item.part != 'straw') {
                    const colorSwatch = item.selectedVariant.colour_swatch;
                    if (!firstColorSwatch) {
                        firstColorSwatch = colorSwatch;
                    }
                    else if (colorSwatch.color !== firstColorSwatch.color) {
                        allTheSame = false;
                    }
                }
            }
        }
        return {
            allTheSame: allTheSame,
            swatch: firstColorSwatch,
        };
    };
    useEffect(() => {
        const allColoursTheSame = [];
        currentBundle.forEach((bundleProd) => {
            return allColoursTheSame.push(checkIfAllColourSwatchesAreSame(bundleProd));
        });
        setSolidSelected(allColoursTheSame.every((prod) => prod.allTheSame === true) ? allColoursTheSame[0].swatch : null);
        // Hide / Show Arrows based on Cursor Position
        if (emblaContainer && emblaContainer.current) {
            let viewportNodeHalfWidth = emblaContainer.current.offsetWidth / 2, viewportNodeBounding = emblaContainer.current.getBoundingClientRect(), viewportLeft = viewportNodeBounding.left, viewportRight = viewportNodeBounding.right;
            window.addEventListener('resize', () => {
                viewportNodeHalfWidth = emblaContainer.current.offsetWidth / 2;
                viewportNodeBounding = emblaContainer.current.getBoundingClientRect();
                viewportLeft = viewportNodeBounding.left;
                viewportRight = viewportNodeBounding.right;
            });
            emblaContainer.current.addEventListener('mousemove', (e) => {
                emblaContainer.current.classList.remove(classes.hoverRight);
                emblaContainer.current.classList.remove(classes.hoverLeft);
                if (e.clientX > viewportLeft && e.clientX < viewportLeft + viewportNodeHalfWidth) {
                    emblaContainer.current.classList.add(classes.hoverLeft);
                }
                if (e.clientX > viewportLeft + viewportNodeHalfWidth && e.clientX < viewportRight) {
                    emblaContainer.current.classList.add(classes.hoverRight);
                }
            });
            emblaContainer.current.addEventListener('mouseleave', () => {
                emblaContainer.current.classList.remove(classes.hoverLeft);
                emblaContainer.current.classList.remove(classes.hoverRight);
            });
        }
    }, [currentBundle]);
    useEffect(() => {
        const placeholder = document.querySelector('[data-fg-cust--solid-colours] .product__swatch-skeleton');
        if (placeholder) {
            placeholder.remove();
        }
    }, []);
    if (commonColours.length == 0)
        return null;
    const handleize = (string) => {
        return string.toLowerCase().replace(' ', '-');
    };
    return (React.createElement("div", { className: "fg-cust-solid-colours" },
        React.createElement("div", { ref: emblaContainer, className: "embla" },
            React.createElement("div", { ref: emblaRef, className: "embla__viewport is-draggable" },
                React.createElement("div", { className: "embla__container" }, commonColours.map((colour, index) => (React.createElement("div", { className: "embla__slide", key: index },
                    React.createElement("button", { className: `fg-cust-solid-colours__swatch fg-cust-solid-colours__swatch--${handleize(colour.name)} ${!colour.available ? `fg-cust-solid-colours__swatch--disabled` : ``} ${solidSelected && solidSelected.name === colour.name ? 'selected' : ''}`, onClick: () => selectSolidColor(colour.name), style: { '--swatch-color': colour.color }, "aria-label": colour.name }, colour.image ? (React.createElement("img", { height: 60, width: 60, src: colour.image })) : null),
                    React.createElement("div", { className: "fg-cust-solid-colours__swatch-label" }, colour.name))))),
                React.createElement(PrevButton, { onClick: onPrevButtonClick, disabled: prevBtnDisabled }),
                React.createElement(NextButton, { onClick: onNextButtonClick, disabled: nextBtnDisabled })))));
};
export default SolidColours;
